import { render, staticRenderFns } from "./ScoringMultipliersData.vue?vue&type=template&id=d2ce1a94"
import script from "./ScoringMultipliersData.vue?vue&type=script&lang=js"
export * from "./ScoringMultipliersData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports